import useLazySelector from "common/redux/useLazySelector";
import { DeliveryMethodDetails } from "domain/deliveryMethod";
import { loadDeliveryMethods } from "./deliveryMethods.actions";

export default function useDeliveryMethods(): DeliveryMethodDetails[] {
    return useLazySelector(m => m.deliveryMethods, dispatch => loadDeliveryMethods()(dispatch), null, []);
}